export const environment = {


  // staging onboarding api url

  // imageBaseUrl: 'https://staging-api2.paycentral.co.za/',
  // apiBaseUrl: 'https://staging-api2.paycentral.co.za',


  // preprod onboarding api url

  // imageBaseUrl: 'https://pc-preprodapi.xenovex.com/',
  // apiBaseUrl: 'https://pc-preprodapi.xenovex.com',

  // Live onboarding api url

  imageBaseUrl: 'https://api2.paycentral.co.za',
  apiBaseUrl: 'https://api2.paycentral.co.za',

  tokenEndPoint: '/api/token',
  production: false,
  environment: 'Local',
  showEnvironment: true,
};
